import { User } from '@/types/user';

import { ExtraFunctions, IStorage, IStorageEngine } from './types';

export class BaseStorage extends EventTarget implements IStorage {
	private engine: IStorageEngine;
	private extra?: ExtraFunctions;

	constructor(engine: IStorageEngine, extra?: ExtraFunctions) {
		super();
		this.engine = engine;
		if (extra) {
			this.extra = {
				onSet: extra.onSet?.bind(this),
				onRemove: extra.onRemove?.bind(this),
			};
		}
	}

	setItem(key: string, value: string) {
		this.engine.setItem(key, value);
		this.extra?.onSet?.(key, value);
	}

	getItem(key: string) {
		return this.engine?.getItem(key);
	}

	removeItem(key: string) {
		this.engine?.removeItem(key);
		this.extra?.onRemove?.(key);
	}

	hasItem(key: string) {
		const val = this.engine?.getItem(key);
		return val !== null && val !== undefined;
	}

	setItemWithUserData(key: string, value: string, user: User) {
		this.engine?.setItem(`${key}-${user?.id}`, value);
	}

	setItemFromObjWithUserData<T extends object>(data: T, fields: (keyof T & string)[], user: User) {
		fields.forEach((field) => {
			if (field in data) {
				this.engine?.setItem(`${field}-${user?.id}`, String(data[field]));
			}
		});
	}

	getItemWithUserData<T>(key: string, user: User, defaultValue: T = null) {
		const value = this.engine?.getItem(`${key}-${user?.id}`);
		return value && value !== 'null' ? value : defaultValue;
	}

	deleteAllUserData(user: User) {
		const keys = Object.keys(this.engine);

		if (user?.id) {
			keys
				.filter((key) => key.includes(String(user.id)))
				.forEach((key) => {
					this.engine?.removeItem(key);
					this.extra?.onRemove?.(key);
				});
		}
	}
}
